import Vue from 'vue';
import services from '../http/request'
import resource from './datalead-resource';
import messenger from '../messenger/messenger';

const common = {
    getBrowserLang() {
      return "pt-BR";
      //return navigator.language || navigator.userLanguage || "pt-BR";
    },
    isRunLocal: function (args, callback) {
      var baseUrl = window.location.host + '';
      return baseUrl.search(/localhost/gi) >= 0 || baseUrl.search(/127.0.0.1/gi) >= 0 || baseUrl.search(/0.0.0.0/gi) >= 0;
    },
    nano(template, data) {
      return template.replace(/\{([\w\.]*)\}/g, function (str, key) {
        const keys = key.split(".");
        let v = data[keys.shift()];
        let i = 0;
        const l = keys.length;
        for (; i < l; i++) v = v[keys[i]];
        return (typeof v !== "undefined" && v !== null) ? v : "";
      });
    },
    getMaxZ() {
      return Math.max.apply(null, $.map($('body > *, .e-dialog'), function (e, n) {
        return parseInt($(e).css('z-index')) || 0;
      }));
    },
    postPurchase(args) {
      try {
        let baseJWT = Vue.prototype.$foundation.getUserToken();
        let leadJWT = Vue.prototype.$foundation.getUserToken();

        if ((!baseJWT || baseJWT === '' || baseJWT === "") || (!leadJWT || leadJWT === '' || leadJWT === "")) {
          messenger.show({text: resource.Languages[common.getBrowserLang()].NotAuthenticatedYet, type: "error"});
          return;
        }

        if (!args.filter) {
          messenger.show({text: resource.Languages[common.getBrowserLang()].AnyFilterDefined, type: "error"});
          return;
        }

        //let request = new services({environment: 'local', tag: 'das'});
        let request = new services({tag: 'das'});
        //let endPoint = `/api/0.1-a/billing/${args["tag"]}/${args["tick"]}`;
        let endPoint = `/api/0.1-a/billing/purchase`;
        let config = {
          headers: {
            "Authorization-DataLead": leadJWT,
            'Content-Type': 'application/json'
          }
        };

        let data = JSON.stringify({
          "alias": args.alias,
          "filter": args.filter
        });
        let callback = args.callback;

        request.post(endPoint, data, config, (response) => {
          if (typeof callback === "function")
            callback(response.data);
        }, (error) => {
          let failOnBuy = "Não foi possível processar sua compra.<br/>";
          if (error.response && error.response.data && error.response.data.message) {
            failOnBuy += `<br/>${error.response.data.message}`;
            messenger.show({text: failOnBuy, type: "error"});
          } else
            messenger.show({text: resource.Languages[common.getBrowserLang()].Sorry, type: "error"});
        });
      } catch (e) {
        console.log(e);
        messenger.error({position: 'top-end', title: e.message});
      }
    },
    processPurchase(args) {
      if (args === undefined ||
        !args.hasOwnProperty("gdIdEvent") ||
        !args.hasOwnProperty("bOverflow") ||
        !args.hasOwnProperty("cOverflow")) {
        let msg = `${resource.Languages[common.getBrowserLang()].FailOnBuy}</br>Detalhes:&nbsp;<b>${args}</b>`;
        messenger.show({text: msg, type: "error"});
      } else {
        let options = {
          title: resource.Languages[common.getBrowserLang()].dataAccessAlertTitle,
          text: "",
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: resource.Languages[common.getBrowserLang()].Yes,
          cancelButtonText: resource.Languages[common.getBrowserLang()].No
        };

        switch (args["cOverflow"]) {
          case "locked":
            if (args["bOverflow"] === true) {
              //#region parse values
              options.confirmButtonText = "Entendi";
              let dataLeadMsgLock = common.nano(resource.Languages[common.getBrowserLang()].dataLeadDefaultMsgLock, {
                0: args["cUser"],
                1: args["nLimit"],
                2: new Date(args["dtInit"]),
                3: new Date(args["dtEnd"]),
                4: resource.Languages[common.getBrowserLang()].SuportEmail
              });

              //#endregion

              //#region set template
              options.text = dataLeadMsgLock;
              //#endregion
            } else {
              options.confirmButtonText = "Entendi";
              options.text = resource.Languages[common.getBrowserLang()].Wonderful + "\n" + resource.Languages[common.getBrowserLang()].Transaction + " " + args["gdIdEvent"];
              options.type = "info";
            }

            messenger.show(options);

            //#region set events

            if (common.isRunLocal()) console.log("data-lead-locked: " + args["gdIdEvent"]);

            //endregion
            break;
          case "payperlead":
            //#region parse values
            let nCountChunk, nCountCoexist, nCountExist, nNewOnes, dStart, dEnd;
            nCountChunk = args["nCountChunk"];
            nCountCoexist = args["nCountCoexist"];
            nCountExist = args["nCountExist"];
            nNewOnes = nCountChunk - nCountCoexist;
            dStart = new Date(args["dtInit"]);
            dEnd = new Date(args["dtEnd"]);

            const dataLeadMsgPayperLead = common.nano(resource.Languages[common.getBrowserLang()].dataLeadDefaultMsgPayperLead, {
              0: args["cUser"],
              1: args["nLimit"],
              2: dStart.toGMTString(),
              3: dEnd.toGMTString(),
              4: resource.Languages[common.getBrowserLang()].SuportEmail,
              5: nNewOnes,
              6: nCountExist,
              7: nCountChunk - nCountCoexist + nCountExist
            });

            //endregion

            //#region set events
            if (nNewOnes > 0) {
              let dialogOptions = {
                title: resource.Languages[common.getBrowserLang()].dataAccessAlertTitle,
                text: dataLeadMsgPayperLead,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: resource.Languages[common.getBrowserLang()].Yes,
                cancelButtonText: resource.Languages[common.getBrowserLang()].No
              };

              messenger.show(dialogOptions).then((result) => {
                if (result.value){
                  args.buttonYes = true;
                  args.callback = common.processPurchaseMessage;
                  common.purchaseConfirm(args);
                } else {
                  common.processPurchaseMessage(args["gdIdEvent"], false)
                }
              });
            } else {
              messenger.show({text: resource.Languages[common.getBrowserLang()].Wonderful + "\n" + resource.Languages[common.getBrowserLang()].Transaction + " " + args["gdIdEvent"], type: "info"});
              if (common.isRunLocal()) console.log("data-lead-payperlead-auto-approve: " + args["gdIdEvent"]);
            }
            //endregion
            break;
          case "unlocked":
            let msg = resource.Languages[common.getBrowserLang()].Wonderful + "\n" + resource.Languages[common.getBrowserLang()].Transaction + " " + args["gdIdEvent"];
            options.text = msg;
            messenger.show(options);
            if (common.isRunLocal()) console.log("data-lead-unlocked: " + args["gdIdEvent"]);
            break;
          default:
            //download now!
            let msg2 = resource.Languages[common.getBrowserLang()].Wonderful + "\n" + resource.Languages[common.getBrowserLang()].Transaction + " " + args["gdIdEvent"];
            options.text = msg2;
            messenger.show(msg2);
            if (common.isRunLocal()) console.log("data-lead-fail: " + args["gdIdEvent"]);
            break;
        }
      }
    },
    processPurchaseMessage(event, confirmed, response) {
      if (confirmed) {
        messenger.show({
          text: resource.Languages[common.getBrowserLang()].Wonderful + "\n" + resource.Languages[common.getBrowserLang()].Transaction + " " + event,
          type: "success"
        });
        if (common.isRunLocal()) console.log("data-lead-payperlead-approved: " + event);
      } else {
        messenger.show({
          text: resource.Languages[common.getBrowserLang()].ChangeYourMind + "<br/>" + resource.Languages[common.getBrowserLang()].Transaction + " " + event,
          type: "info"
        });
        if (common.isRunLocal()) console.log("data-lead-payperlead-not-approved: " + event);
      }
    },
    purchaseConfirm(args){
      let baseJWT, leadJWT, gdIdEvent, bConfirm, dtConfirm;
      let date = new Date(Date.now());

      //region initialize

      if (!args) {
        messenger.show({text: resource.Languages[common.getBrowserLang()].InvalidArgs, type: "warning"});
        return;
      }

      try {
        bConfirm = args.hasOwnProperty("buttonYes") ? args["buttonYes"] : true;
        dtConfirm = args.hasOwnProperty("dtConfirm") ? args["dtConfirm"] : date.toLocaleString(common.getBrowserLang());
        gdIdEvent = args.hasOwnProperty("gdIdEvent") ? args["gdIdEvent"] : null;
        baseJWT = Vue.prototype.$foundation.getUserToken();
        leadJWT = Vue.prototype.$foundation.getUserToken();
      } catch (e) {
        //ignore
      }

      //endregion

      //region token

      if ((!gdIdEvent || gdIdEvent === '' || gdIdEvent === "")) {
        messenger.show({text: resource.Languages[common.getBrowserLang()].InvalidArgs, type: "warning"});
        return;
      }

      if ((!baseJWT || baseJWT === '' || baseJWT === "") || (!leadJWT || leadJWT === '' || leadJWT === "")) {
        messenger.show({text: resource.Languages[common.getBrowserLang()].NotAuthenticatedYet, type: "warning"});
        return;
      }

      //endregion

      //region wrapping

      let params = {
        "dtConfirm" : dtConfirm,
        "bConfirm": bConfirm
      };

      //endregion

      //let request = new services({environment: 'local', tag: 'das'});
      let request = new services({tag: 'das'});
      let endPoint = `/api/0.1-a/billing/${gdIdEvent}`;
      let config = {
        headers: {
          "Authorization-DataLead": leadJWT,
          'Content-Type': 'application/json'
        }
      };
      let data = JSON.stringify(params);
      let callback = args.callback;
      let event = args.gdIdEvent;

      request.patch(endPoint, data, config, (response) => {
        if (typeof callback === "function")
          callback(event, bConfirm, response);
      }, (error) => {
        messenger.show({text: resource.Languages[common.getBrowserLang()].Sorry, type: "error"});
        console.log(error)
      });
    },
};

export default common;
